import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const StyledSection = styled.section`
  ${({ theme }) => theme.mixins.section};
  background-color: var(--ink-950);
  background-image: radial-gradient(760px 420px at 50% 0%, rgba(86, 112, 246, 0.32), transparent 60%),
    radial-gradient(620px 380px at 100% 100%, rgba(253, 118, 255, 0.18), transparent 62%);
  color: var(--on-dark-soft);

  .eyebrow {
    color: var(--blue-bright);
  }
`;

const StyledInner = styled.div`
  ${({ theme }) => theme.mixins.container};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const StyledCard = styled.div`
  max-width: 760px;
  padding: 56px 40px;
  border: 1px solid var(--on-dark-line);
  border-radius: var(--radius-xl);
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(6px);

  @media (max-width: 560px) {
    padding: 40px 24px;
  }

  h2 {
    margin: 0 0 16px;
    color: #ffffff;
    font-size: clamp(1.9rem, 3.4vw, 2.8rem);
  }

  p {
    max-width: 540px;
    margin: 0 auto 32px;
    color: var(--on-dark-soft);
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    justify-content: center;
  }

  .primary {
    ${({ theme }) => theme.mixins.primaryButton};
  }

  .secondary {
    ${({ theme }) => theme.mixins.outlineButton};
  }
`;

const CTA = () => (
  <StyledSection id="cta">
    <StyledInner>
      <StyledCard>
        <p className="eyebrow">Сотрудничество</p>
        <h2>Обсудим ваш проект?</h2>
        <p>
          Расскажите о задаче — я помогу оценить объём работ, предложу решение и подскажу, с чего
          начать. Консультация ни к чему не обязывает.
        </p>
        <div className="actions">
          <Link className="primary" to="/contacts">
            Обсудить проект
          </Link>
          <Link className="secondary" to="/contacts">
            Связаться
          </Link>
        </div>
      </StyledCard>
    </StyledInner>
  </StyledSection>
);

export default CTA;
